import { Component } from "react";
import DataTable from "react-data-table-component";
import ContentContainer from "../../../containers/UI/ContentContainer/ContentContainer";
import axios from "../../../axios";
import CompanyModal from "./CompanyModal/CompanyModal";

const columns = [
  { name: "Company Name", selector: "companyName", sortable: true, style: { fontSize: "15px" }},
  { name: "Country", selector: "country", sortable: true, style: { fontSize: "14px" }},
  { name: "Members", selector: "memberCount", sortable: true, style: { fontSize: "14px" }},
  { name: "Organization Number", selector: "orgAccountNumber", sortable: true, style: { fontSize: "14px" }},
]

class Companies extends Component {

  state = {
    companies: [],
    selectedCompany: null,
    showCompanyModal: false
  }

  componentDidMount() {
    this.loadCompanies();
  }

  loadCompanies = () => {
    axios.get("/platforms/companies")
      .then(response => {
        if (response.data && response.data.companies) {
          this.setState({ companies: response.data.companies });
        }
      })
      .catch(err => {
        console.error("Failed to load companies:", err);
      });
  }

  closeModal = () => {
    this.setState({ showCompanyModal: false, selectedCompany: null });
    setTimeout(() => {
      this.loadCompanies();
    }, 500);
  }

  render() {
    return (
      <ContentContainer title="Companies">
        <DataTable
          columns={columns}
          data={this.state.companies}
          noHeader={true}
          pagination={true}
          highlightOnHover={true}
          striped={true}
          defaultSortField={"companyName"}
          defaultSortAsc={true}
          customStyles={{
            headCells: { style: { fontWeight: "bold", fontSize: "15px" }}
          }}
          onRowClicked={(company) => this.setState({ showCompanyModal: true, selectedCompany: company })}
        />

        {this.state.showCompanyModal && (
          <CompanyModal
            shouldShow={this.state.showCompanyModal}
            selectedCompany={this.state.selectedCompany}
            closeModal={() => this.closeModal()}
          />
        )}
      </ContentContainer>
    );
  }
}

export default Companies;
